import { render, staticRenderFns } from "./GiftShopMobile.vue?vue&type=template&id=47585ddc"
import script from "./GiftShopMobile.vue?vue&type=script&lang=js"
export * from "./GiftShopMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports